<template>
    <div class="v-searchListIndex">
        <DetailHead />
        
        <h5 class="searchListIndex-reslut">共搜索到&nbsp;{{dt_pagination.total}}&nbsp;个作品</h5>

        <section class="searchListIndex-section">
            <project 
                v-for="(item, index) in dt_projectList"
                :key = "index"
                :pr_data = "item"
                @click.native="fn_skipProject(item.gindex)"
            >
            </project>
        </section>


        <footer v-show="dt_pagination.total" class="searchListIndex-footer">
            <el-pagination
            @size-change="fn_sizeChange"
            @current-change="fn_sizeChange"
            :current-page.sync="dt_pagination.cur_page"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="dt_pagination.total"
            >
            </el-pagination>
        </footer>

    </div>
</template>
<script>
import  project from './components/project'
import { axiosGetGamebyKeyword } from '@/service/api.js'
import DetailHead from '../detail/components/DetailHead'
import { mapState } from 'vuex'

export default {
     beforeRouteEnter (to, from, next) {
       next(vm => {
           if (from.name && from.name.indexOf('home') != -1 && to.params.type == 'home') {
                if (vm.vx_searchText) {
                    vm.ut_openLoading();
                    vm.fn_search(vm.vx_searchText);
                } else {
                    vm.$message.success("没有搜索到任何相关作品");
                }
           }
        })
     },
    created() {
        // if (this.dt_isDefaultSearch) {
        //     if (this.vx_searchText) {
        //         this.fn_search(this.vx_searchText);
        //     } else {
        //         this.$message.success("没有搜索到任何相关作品");
        //     }
        // }
    },
    components: {
     DetailHead,
     project,
    },
    data() {
        return {
            dt_isDefaultSearch: false,
            // 作品列表
            dt_projectList: [],
            dt_shakeTimes: null,
            dt_loading: null,
            // 分页数据配置
            dt_pagination: { 
                // 当前页数
                cur_page: 1,
                total: 0
            }
        }   
    },
    computed: {
         ...mapState([
            'vx_searchText',
        ])
    },
    watch: {
        vx_searchText(text) {
             this.ut_openLoading();
             this.ut_antiShake(async () => {
                this.init_page();
                this.fn_search(text);
             })
        },
    },
    methods: {
        ut_antiShake(callback) {
            clearTimeout(this.dt_shakeTimes);
            this.dt_shakeTimes = setTimeout(()=> {
                clearTimeout(this.dt_shakeTimes);
                callback();
            }, 500)
        },
        init_page() {
            this.dt_pagination.cur_page = 1;
            this.dt_pagination.total = 0;
        },
        async fn_search(text, page) {
            try{
                let {isOk, message, data} =  await axiosGetGamebyKeyword(text, page ? page : this.dt_pagination.cur_page) || {};
                if (isOk) {
                    this.dt_projectList.length = 0;
                    this.dt_projectList.push.apply(this.dt_projectList, data ? data.list : []);
                    if (this.dt_projectList.length%2 != 0) {
                        this.dt_projectList.push({});
                    }
                    if (!data || (data && !data.list.length)) {
                        this.$message.success("没有搜索到任何相关作品");
                    } else {
                        this.dt_pagination.total = data.total;
                        document.body.scrollTop  = document.documentElement.scrollTop = 0;
                    }
                } else {
                    this.$message.error(message ? message.message : "查询作品失败");
                }
                this.dt_loading && this.dt_loading.close();
            }catch(e) {
                console.log("搜索报错了", e);
                this.dt_loading && this.dt_loading.close();
            }
        },
        fn_sizeChange(page) {
            this.ut_openLoading();
            this.ut_antiShake(async () => {
                 this.fn_search(this.vx_searchText, page);
            })
        },
        fn_skipProject(gindex) {
            this.$router.push(`/game/${gindex}`)
        },
        // 打开loading
        ut_openLoading(){
             this.dt_loading && this.dt_loading.close  && this.dt_loading.close();
             this.dt_loading = this.$loading({
                lock: true,
                text: '搜索中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }
    }
}
</script>
<style scoped lang="less">
  
    .v-searchListIndex{
        min-height: 100%;
        padding-bottom: 20px;
        position: relative;
        overflow: hidden;
    }
    .searchListIndex-reslut{
        margin:40px auto;
        width:900px;
        font-size:16px;
        font-weight: 400;
    }
    .searchListIndex-section{ 
        margin:20px auto;
        width:900px;
        overflow: hidden;
    } 
    .searchListIndex-footer {
        position: absolute;
        left:0;
        right:0;
        bottom: 0;
        margin:20px auto;
        width:900px;
        text-align: center;
        overflow: hidden;
    }
</style>

